var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8382_9556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.4082 12.5918H10.867",
    stroke: "black",
    strokeOpacity: 0.87,
    strokeWidth: 1.22842,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.56796 9.58217L3.98828 10.0465L4.41823 7.43244L10.2053 1.66256C10.2852 1.58196 10.3804 1.51799 10.4851 1.47433C10.5899 1.43068 10.7023 1.4082 10.8158 1.4082C10.9293 1.4082 11.0417 1.43068 11.1465 1.47433C11.2513 1.51799 11.3464 1.58196 11.4264 1.66256L12.3378 2.57404C12.4184 2.65398 12.4824 2.74909 12.5261 2.85387C12.5697 2.95866 12.5922 3.07105 12.5922 3.18457C12.5922 3.29808 12.5697 3.41048 12.5261 3.51526C12.4824 3.62005 12.4184 3.71515 12.3378 3.79509L6.56796 9.58217Z",
    stroke: "black",
    strokeOpacity: 0.87,
    strokeWidth: 1.22842,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8382_9556"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditSmall);
export default __webpack_public_path__ + "static/media/editSmall.7096a87bd9b69971fcbe3f9ae4fe73b8.svg";
export { ForwardRef as ReactComponent };